const header = {
  "header.menu_01": "主頁",
  "header.menu_02": "ACUVUE® DEFINE® 系列",
  "header.menu_03": "虛擬試戴",
  "header.menu_04": "立即預約驗配",
  "header.list_menu_01": "主目錄",
  "header.list_menu_02": "DEFINE® CLASSIC",
  "header.list_menu_03": "DEFINE® FRESH",
  "header.store_locator": "搜尋銷售點",
  "header.store_01": "Lazada",
  "header.store_02": "Qoo10",
  "header.store_03": "Shopee",
}

export default header
